<template>
    <section v-if="organizations && organizations.length > 1">
        <h3 class="text-uppercase mt-4">Organizations</h3>
        <hr class="bar my-3" />
        <div
            v-for="organization in organizations"
            class="d-flex justify-content-between align-items-start"
        >
            <div>
                <h5 class="font-weight-bold">{{ organization.name }}</h5>
                <p>
                    Role:
                    {{
                        roles.find(
                            role => role.id === helpers._get(organization, "pivot.role_id", null)
                        ).name
                    }}
                </p>
            </div>
            <button
                :id="`detach-org-${organization.id}`"
                class="btn btn-sm btn-danger text-uppercase"
                :disabled="isLeaveDisabled(organization.id)"
                v-tooltip="
                    isLeaveDisabled(organization.id)
                        ? `Super users cannot leave the organization if there's an active subscription`
                        : null
                "
                @click="leaveOrganization(organization.id)"
            >
                Leave organization
            </button>
        </div>
        <errors :errors="errors"></errors>
    </section>
</template>

<script>
import { errors } from "../../plugins/errors";
import { helpers } from "../../plugins/helpers";

export default {
    name: "AccountOrganizations",
    props: ["user", "organization", "organizations", "subscription", "roles"],
    mixins: [errors],
    methods: {
        isLeaveDisabled(organizationId) {
            const organization = this.organizations.find(
                organization => organization.id === organizationId
            );
            if (organization) {
                if (_.get(organization, "pivot.role_id", null) === 1) {
                    // 1. User is a super
                    if (organizationId === this.organization.id) {
                        // 2. Organization is the active organization
                        return (
                            this.subscription.quantity > 1 || this.subscription.is_subscribed // 3. There are no other users in the organization
                        ); // 4. There is no active subscription --> leave button is enabled.
                    }
                    return false; // Supers can try to detach from organization if it's not active
                }
                return false; // Users that aren't supers can always detach themselves
            }
            return true; // Organization was not found -- this is an error.
        },

        leaveOrganization(organizationId) {
            helpers.toggleSpinner(`detach-org-${organizationId}`);
            if (this.isLeaveDisabled(organizationId)) return;
            this.setErrors();
            axios
                .delete(`/api/organizations/${organizationId}/users/${this.user.id}`)
                .then(response => {
                    window.location.href = "/account-settings";
                })
                .catch(error => {
                    helpers.toggleSpinner(`detach-org-${organizationId}`);
                    this.setErrors([[_.get(error, "response.data.message", {})]]);
                    console.error(error);
                });
        },
    },
};
</script>

<style scoped></style>
